export default "__VITE_ASSET__DZCQwRj3__"